var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSensorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6846 9.06842C13.5856 8.96941 13.5361 8.91991 13.5197 8.86069C13.5052 8.80859 13.5082 8.7515 13.5283 8.6976C13.551 8.63631 13.606 8.58131 13.716 8.47131L17.7229 4.46437L16.3087 3.05015L21.5335 2.77517L21.2585 7.9999L19.8443 6.58569L15.8373 10.5926C15.7273 10.7026 15.6723 10.7576 15.611 10.7804C15.5571 10.8004 15.5 10.8034 15.4479 10.789C15.3887 10.7726 15.3392 10.7231 15.2402 10.6241L13.6846 9.06842Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71054 9.53604C8.3905 10.8561 8.39053 12.9963 9.71057 14.3164C11.0306 15.6364 13.1709 15.6364 14.4909 14.3164M12.7173 3.2166L12.2264 2.13762C12.0524 1.75522 11.6275 1.55466 11.2217 1.66337L7.73057 2.59882C7.3248 2.70756 7.05709 3.0937 7.09762 3.51184L7.21205 4.69175C7.34251 6.03762 6.21215 7.16798 4.86629 7.03751L3.68638 6.92309C3.26824 6.88255 2.88209 7.15026 2.77335 7.55604L1.8379 11.0472C1.72919 11.453 1.92975 11.8779 2.31216 12.0518L3.39114 12.5427C4.62194 13.1027 5.03571 14.6468 4.24975 15.7471L3.56074 16.7117C3.31658 17.0535 3.35532 17.5218 3.65235 17.8188L6.20808 20.3746C6.50511 20.6716 6.97341 20.7104 7.31523 20.4662L8.27984 19.7772C9.38018 18.9912 10.9243 19.405 11.4842 20.6358L11.9751 21.7148C12.1491 22.0972 12.574 22.2977 12.9798 22.189L16.4709 21.2536C16.8767 21.1448 17.1444 20.7587 17.1038 20.3406L16.9895 19.1607C16.859 17.8148 17.9893 16.6844 19.3352 16.8149L20.5151 16.9293C20.9332 16.9698 21.3194 16.7021 21.4281 16.2964L22.3636 12.8052C22.4723 12.3994 22.2717 11.9745 21.8893 11.8006",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorsIcon);
export default __webpack_public_path__ + "static/media/SensorsIcon.76809b81eefff934719c7aee4bc787f1.svg";
export { ForwardRef as ReactComponent };